export default {
  fca1: "FCA 流動性清算帳戶開設流程",
  "fca1-m": "FCA 流動性清算帳戶",
  fca2: "EBC Financial Group (UK) Ltd 是受英國金融市場行為管理局（FCA）授權並監管的綜合金融券商，所有交易訂單直通國際清算池。 監管編號：927552<br><br>在EBC Financial Group (UK) Ltd開設FCA流動性清算賬戶，有權根據FSCS賠償計劃要求最高85000英鎊的賠償。",
  fca3: "歐盟《金融工具市場法規（MiFID）》及其後修訂版MiFID II根據客戶的知識水准、經驗和專長將投資者分為「零售投資者」或「專業投資者」等。<br><br>根據FCA法規，EBC Financial Group (UK) Ltd僅接受專業投資者和機構投資者，可開設杠杆為100倍的FCA流動性清算帳戶，投資者資金將獨立託管於巴克萊銀行。",
  fca4: {
    title: "專業投資者須滿足以下三個標準中的其中兩個",
    "title-m": "個人投資者須滿足三個標準的其中兩個，即可申請為專業投資者",
    desc: "過去一年各季度平均交易次數為<br>10次以上",
    desc1: "持有超過50萬歐元的投資組合，<br>投資組合包括現金儲蓄和金融工具",
    desc2: "於金融行業擁有至少一年的工作經驗，<br>瞭解差價合約/衍生品交易",
  },
  fca5: {
    title: "FCA 流動性清算帳戶開設流程",
    desc: "申請表<br>下載並填寫",
    desc1: "証明文件<br>準備和認證",
    desc2: "以電子郵件<br>遞交資料及申請",
    desc3: "合規審核<br>和文件簽署",
    desc4: "成功開立<br>FCA 帳戶及設定",
    btn: "專業投資者申請表下載",
    btn1: "機構投資者申請表下載",
  },
  fca6: {
    title: "開設 FCA 流動性清算帳戶<br>最權威的監管保護和最安全的資金保障 ",
    "title-m": "FCA帳戶，最權威的監管保護和最安全的資金保障 ",
    desc: "英國金融市場行為管理局（FCA）",
    desc1: "FCA 流動性清算帳戶諮詢郵箱：",
    desc2: "",
  },
  lang: "cn",
  FCA流动性清算账户开设流程: `<span class="fca">FCA</span>流動性清算帳戶開設流程`,
  "EBC Financial Group Limited是受英国金融市场行为管理局（FCA）授权并监管的综合金融券商":
    "EBC Financial Group Limited是受英國金融市場行為管理局（FCA）授權並監管的綜合金融券商，所有交易訂單直通國際清算池。 監管編號：927552",
  "在EBC Financial Group Limited开设FCA流动性清算账户":
    "在EBC Financial Group Limited開設FCA流動性清算帳戶，有權根據FSCS賠償計畫要求最高85000英鎊的賠償。 ",
  "欧盟《金融工具市场法规（MiFID）》及其后修订版MiFID": `歐盟《金融工具市場法規（MiFID）》及其後修訂版MiFID II根據客戶的知識水准、經驗和專長將投資者分為「零售投資者」或「專業投資者」等。`,
  根据FCA法规: `根據FCA法規，EBC Financial Group Limited僅接受專業投資者和機構投資者，可開設杠杆為100倍的FCA流動性清算帳戶，投資者資金將獨立託管於巴克萊銀行隔離帳戶。(Pls check David email on segrefgated account with Barclarys, need to amend this part?)`,
  专业投资者须满足以下三个标准中的其中两个: `專業投資者須滿足以下三個<br class="mobile" />標準中的其中兩個﹕`,
  "过去一年平均交易频率达到10次/季度": "過去一年各季度平均交易次數為10次以上",
  持有超过50万欧元的投资组合:
    "持有超過50萬歐元的投資組合，投資組合包括現金儲蓄和金融工具",
  在金融行业工作或至少工作过一年:
    "於金融行業擁有至少一年的工作經驗，瞭解差價合約/ 衍生品交易",
  FCA流动性清算账户开户流程: `FCA 流動性清算帳戶<br class="mobile" />開設流程`,
  获取申请表: "取得申請表",
  访EBC英国站: "訪EBC英國站，取得申請表",
  提交材料: "提交資料",
  按要求填写: "按要求填寫、上傳申請資料",
  合规审核: "合規審核",
  等待合规审核: "等待合規審核，簽署相關文件",
  开户成功: "開戶成功",
  登录并设置您的FCA账户: "登入並設定您的FCA帳戶",
  最权威的监管保护和最安全的: `開設 FCA 流動性清算帳戶<br />
          最權威的監管保護和最安全的<br class="mobile" />資金保障 `,
  "英国金融市场行为管理局（FCA）": "英國金融市場行為管理局（FCA）",
  FCA流动性清算账户咨询邮箱: ` FCA 流動性清算帳戶諮詢郵箱：
            <a href="mailto:support@ebcfin.co.uk">support@ebcfin.co.uk</a>`,
};
